import { FunctionComponent, useEffect, useRef } from "react";
import { selectAreaInfo } from "../../../area-info/redux/selectors/select-area-info";
import { selectTotalHomeCount } from "../../redux/selectors/select-total-home-count";
import { selectTotalCommunityCount } from "../../redux/selectors/select-total-community-count";
import { useAppSelector } from "../../../system/redux/hooks/redux-store-hooks";
import { selectPageOfMatchedResults } from "../../redux/selectors/pagination/select-page-of-matched-results";

const NoResultCard: FunctionComponent = () => {
	const coinImageRef = useRef(null);

	useEffect(() => {
		if (coinImageRef.current && coinImageRef.current.classList.contains("in-view")) {
			// after 1 second (the duration of the animation), remove the in-view class
			setTimeout(() => {
				coinImageRef.current.classList.remove("in-view");
			}, 1000);
		}
	}, []);

	const areaInfo = useAppSelector(selectAreaInfo);
	const currentPageOfResults = useAppSelector(selectPageOfMatchedResults);
	const totalHomeCount = useAppSelector(selectTotalHomeCount);
	const homeCountExcludingHOTW = totalHomeCount - currentPageOfResults.length;
	const totalCommunityCount = useAppSelector(selectTotalCommunityCount);
	const handleCoinClick = (e: React.MouseEvent<HTMLButtonElement>) => {
			var videoModal = document.getElementById("hotw-modal");
			const url = new URL(window.location.href);
			url.searchParams.set("homes", "hotw");
			url.searchParams.set("video", "hotw");
			window.history.pushState(null, null, url);
	
			videoModal.setAttribute("style", "display: block");
			document.body.classList.add("modal-open");
		}
	var communityVerbiage = (totalCommunityCount == 1) ? "1 community" : totalCommunityCount + " communities"

	var noResultsVerbiage = "";

	var noResultsSubVerbiage = homeCountExcludingHOTW == 1 ? 
		"We have 1 other home for sale in the " + areaInfo.Name + " area. Browse our communities to find a tour." : 
		(homeCountExcludingHOTW == 0 ? 
			"We have " + communityVerbiage + " in " + areaInfo.Name + ". Browse to find a tour." :
			"We have " + homeCountExcludingHOTW + " other homes for sale in the " + areaInfo.Name + " area. Browse our communities to find a tour."
		)
		
	//noResultsSubVerbiage = totalHomeCountVerbiage + " " + areaInfo.Name + " area. Browse our communities to find a tour.";

	if (currentPageOfResults?.length < 4 && currentPageOfResults?.length > 0)
		noResultsVerbiage = "That wraps up our homes of the week!";
	else {
		if (totalCommunityCount > 0) {
			noResultsVerbiage = "Fresh out of featured homes, but there's still plenty to see!";
		} else {
			noResultsVerbiage = "Oops, no homes here.";
			noResultsSubVerbiage = "Explore the map to find a new area with homes near you.";
		}
	}
	
	const noResultsClass = currentPageOfResults?.length < 4 && currentPageOfResults?.length > 0 ?
		"hotw-banner some-results" :
		"hotw-banner hotw-no-results";

	const handleTileClick = (e: React.MouseEvent<HTMLDivElement>) => {
			var breadcrumbs = document.getElementsByClassName("breadcrumbs")[0];
			// for tablet and mobile
			var tabAnchor = document.getElementsByClassName("tab-anchor")[0];
			breadcrumbs ? breadcrumbs.scrollIntoView({block: 'start', behavior: 'smooth'}) : tabAnchor.scrollIntoView({block: 'start', behavior: 'smooth'});
			document.getElementById("communityTab").click();
		}

	return (
		<div className="coveo-list-layout CoveoResult no-results-tile" role="listitem" aria-label="View communities card">
			<div
				role="link"
				tabIndex={0}
				aria-label="View communities"
				onClick={handleTileClick}
			>
				<div className={noResultsClass}>
					{currentPageOfResults?.length === 0 &&
						<div className="coin-container">
							<button aria-label="Watch video about homes of the week" className="hotw-wrapper hotw-tile" onClick={(e) => handleCoinClick(e)}>
								<img 
									alt=""
									ref={coinImageRef} 
									className="hotw-coin in-view"
									src="/-/media/hotw_coin_flat.png"
									onMouseEnter={() => {
										if (coinImageRef.current) {
											coinImageRef.current.classList.add("in-view");
										}
										// after 1 second (the duration of the animation), remove the in-view class
										setTimeout(() => {
											if (coinImageRef.current && coinImageRef.current.classList.contains("in-view")) {
												coinImageRef.current.classList.remove("in-view");
											}
										}, 1000);
									}}
								/>
								<div className="hotw-coin-shadow"></div>
							</button>
						</div>
					}
					<div className="no-results-descr">
						<h2>{noResultsVerbiage}</h2>
						<p>{noResultsSubVerbiage}</p>
						{totalCommunityCount > 0 && <span className="btn" /* onClick={(e) => document.getElementsByClassName("breadcrumbs")[0].scrollIntoView({block: 'start', behavior: 'smooth'})} */>View communities</span>}
					</div>
				</div>
			</div>
		</div>
    );
};

export default NoResultCard;